module.exports = __webpack_public_path__ + "static/media/powered_by_stripe.1ebaf4af.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/candidate/assets/powered_by_stripe.svg
// module id = 1638
// module chunks = 0